/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { jingleCollectionInfoModelSchema } from "../jingleCollectionInfoModelSchema.ts";
import { z } from "zod";

export const getApiJingleCollectionsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки")
    })

/**
 * @description Подборка джинглов
 */
export const getApiJingleCollectionsId200Schema = z.lazy(() => jingleCollectionInfoModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiJingleCollectionsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiJingleCollectionsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiJingleCollectionsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Подборка не найдена
 */
export const getApiJingleCollectionsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiJingleCollectionsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiJingleCollectionsIdQueryResponseSchema = z.lazy(() => getApiJingleCollectionsId200Schema)